export default __webpack_public_path__ + "static/media/express.450277c5.png";